import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '../services/translation/translate.service';

@Pipe({
    name: 'translate',
    standalone: false
})

export class TranslatePipe implements PipeTransform {
  constructor(
    private translate: TranslateService,
  ) {}
  transform(value: any, replace?:any, part?:number): any {
    return value !== '' ? this.translate.get(value, replace, part) : '';
  }
}